import { firestore, db } from "../firebase";

export async function add(user) {
  db.collection("logins").add({
    ts: firestore.Timestamp.now(),
    user: { ...user },
  });
}
